import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { ActionButton, Form, ModalDialog, SubmitButton, Success, TextField } from "@culturehq/components";
import client from "@culturehq/client";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";
import CancelEventType from "./CancelEventType";

const initialState = {
  open: false,
  selected: "cancel",
  success: false,
  error: false,
  redirectTo: false
};

const getSubmitText = selected => {
  const resting = selected === "cancel" ? t("Cancel Event") : t("Delete Event");
  return submitting => (submitting ? t("Submitting...") : resting);
};

class CancelEventContext extends Component {
  state = initialState;

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleTypeClick = selected => {
    this.setState({ selected });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false, ...initialState });
  };

  handleSubmit = async ({ message }) => {
    const {
      event: { id: eventId },
      onEventUpdate,
      onUserActivityRemove,
      userActivity,
      onEventDelete
    } = this.props;
    const { selected: type } = this.state;

    this.setState({ success: false, error: false });

    let event;

    try {
      if (type === "delete") {
        await client.deleteEvent({ eventId, message });
      } else {
        ({ event } = await client.cancelEvent({ eventId, message }));
      }

      if (this.componentIsMounted) {
        this.setState({
          success: type === "cancel" ? t("Event has been cancelled") : t("Event has been deleted"),
          error: false,
          redirect: false,
          open: false
        });
      }

      if (event) {
        onEventUpdate(event);
      } else if (onEventDelete) {
        // delete from events feed
        onEventDelete(eventId);
      } else if (onUserActivityRemove) {
        // delete from feed
        onUserActivityRemove(userActivity.id);
      } else {
        // delete from event page
        this.setState({
          redirect: "/events"
        });
      }
    } catch (error) {
      if (this.componentIsMounted) {
        this.setState({ error, success: false });
      }
    }
  };

  render() {
    const { redirect, open, error, success, selected } = this.state;

    if (redirect) {
      return <Redirect to={redirect} />;
    }

    return (
      <>
        <ActionButton icon="ios-close-outline" onClick={this.handleOpen}>
          <Trans>Cancel Event</Trans>
        </ActionButton>
        {open && (
          <ChqModalDialog className="cancel-event" onClose={this.handleClose}>
            <ModalDialog.Heading onClose={this.handleClose}>
              <Trans>Cancel this Event</Trans>
            </ModalDialog.Heading>
            <ModalDialog.Body>
              {success && <Success>{success}</Success>}

              {!success && (
                <>
                  <CancelEventType
                    selected={selected}
                    type="cancel"
                    onClick={this.handleTypeClick}
                  />
                  <CancelEventType
                    selected={selected}
                    type="delete"
                    onClick={this.handleTypeClick}
                  />
                  <Form onSubmit={this.handleSubmit}>
                    {error && <ErrorMessage error={error} />}

                    <TextField name="message">
                      <Trans>Send notification to guests with more info: (optional)</Trans>
                    </TextField>
                    <SubmitButton danger fillParent>
                      {getSubmitText(selected)}
                    </SubmitButton>
                  </Form>
                </>
              )}
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

const CancelEvent = ({
  event,
  onEventUpdate,
  onUserActivityRemove = null,
  userActivity = null,
  onEventDelete = null
}) => {
  const { profile } = useProfile();

  if (!event.isUserHostOrAdmin(profile)) {
    return null;
  }

  return (
    <CancelEventContext
      event={event}
      onEventUpdate={onEventUpdate}
      onUserActivityRemove={onUserActivityRemove}
      userActivity={userActivity}
      onEventDelete={onEventDelete}
    />
  );
};

export default CancelEvent;
